import { render } from "./mechanism.vue?vue&type=template&id=d667e852"
import script from "./mechanism.vue?vue&type=script&lang=js"
export * from "./mechanism.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__